import axios from 'axios'
/*
 getUserSimpleInfo 获取用户个人资料
 getAllGrade 获取所有年级
 getUnreadMessageSum 获取所有未读信息总和
 getAllDifficultConstant 获取所有的难度常量列表
 getAllSubjectConstant 获取所有的科目常量列表
 */
// 获取用户个人资料
export function getUserSimpleInfo (datas) {
  const url = '/userCommon/getUserSimpleInfo'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取所有未读信息总和
export function getUnreadMessageSum (datas) {
  const url = '/userCommon/getUnreadMessageSum'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取所有年级
export function getAllGrade (datas) {
  const url = '/userCommon/getAllGrade'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取所有的难度常量列表
export function getAllDifficultConstant (datas) {
  const url = '/userCommon/getAllDifficultConstant'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取所有的科目常量列表
export function getAllSubjectConstant (datas) {
  const url = '/userCommon/getAllSubjectConstant'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 学生端查询菜单列表
export function queryStuMenuList (datas) {
  const url = '/userCommon/queryStuMenuList'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 学生端查询按钮列表
export function queryStuButtonPermission (datas) {
  const url = '/userCommon/queryStuButtonPermission'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取教师资质公示
export function getPublicityInfo (datas) {
  const url = '/userCommon/getPublicityInfo'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取教师资质列表
export function getQualificatePage (datas) {
  const url = '/userCommon/getQualificatePage'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取公司id
export function getSaasCompanyInfoByDomain (datas) {
  const url = '/sass/companyinfo/getSaasCompanyInfoByDomain'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 根据公司ID获得saas公司基本信息
export function getSaasCompanyInfoById (datas) {
  const url = '/sass/companyinfo/getSaasCompanyInfoById'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// saas公司协议列表
export function getSaasAgreementInfoByTypeArrayList (datas) {
  const url = '/sass/companyinfo/getSaasAgreementInfoByTypeArrayList'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}
// 获取时区列表
export function queryTimeZoneList (datas) {
  const url = '/userCommon/queryTimeZoneList'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 添加访问记录
export function addRecord (datas) {
  const url = `/visitRecord/addRecord`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 菜单列表
export function menuBarList (datas) {
  const url = '/menu/menuBarList'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/public/public.js